/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { createReducer, on } from '@ngrx/store';
import { FittingTreeView } from '../../models/fitting-tree-view-vm';
import {
  GetResultInformationFromTreeViewFolderSuccess,
  GetTreeViewRootDirectorySucces,
} from './fitting-tree-view-actions';
import { ResultInformation } from '../../models/result-information';

export const FittingTreeViewKey = 'FittingTreeView';

export interface FittingTreeViewState {
  treeViewItems: any;
  updatedTreeViewItem: FittingTreeView;
  treeViewResultInformation: ResultInformation[];
}

export const initialFittingTreeViewState: FittingTreeViewState = {
  treeViewItems: [],
  updatedTreeViewItem: new FittingTreeView(),
  treeViewResultInformation: [],
};

export const FittingTreeViewReducer = createReducer(
  initialFittingTreeViewState,  

  on(GetResultInformationFromTreeViewFolderSuccess, (state, action) => ({
    ...state,
    treeViewResultInformation: action.resultInformation,
  })),

  on(GetTreeViewRootDirectorySucces, (state, action) => ({
    ...state,
    treeViewItems: action.response,
  }))
);